export default "__VITE_ASSET__CPZLpsK8__"